import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import App from "./App";
import { ToastContainer } from "react-toastify";
import { ThemeProvider, useTheme } from "./hooks/useTheme";

// ToastContainer renders outside <App/>, so it needs its own bridge into
// ThemeProvider's context to pick up the light/dark toast palette.
const ThemedToastContainer: React.FC = () => {
  const { theme } = useTheme();
  return <ToastContainer theme={theme} />;
};

const rootElement = document.getElementById("root") as HTMLElement;
const app = (
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <App />
        <ThemedToastContainer />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

// react-snap leaves prerendered markup in #root - hydrate onto it instead of
// wiping it with a fresh client render, so crawlers/link-unfurlers that
// don't run JS still see real content.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
